<!-- EM_MO_SB_027  하한선/월정액 자동충전 -->
<template>
  <div>
    <div class="autocharging-detail-top">
      <span class="card-image shadow" :style="{ backgroundImage:'url('+cardInfo.thumbnailImageUrl+')'}"></span>
      <div class="mb-24">
        <!--<em>{{autoReloadData.remainCash | comma}}</em>-->
        <em>{{Number(autoReloadData.remainCash).toLocaleString()}}</em>
        <strong style="padding-bottom: 0;">{{ cardInfo.prepaidCardNickName != null? cardInfo.prepaidCardNickName : cardInfo.giftMessage != null? cardInfo.giftMessage : '' }}</strong>
        <span>구매일<small>{{autoReloadData.issueDate}}</small></span>
      </div>
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="flex-y-center radio-wrap px-20">
      <label class="radiobox">
        <input type="radio" name="autocharging" value="AMOUNT"
               @click="clickRadio($event.target.value)"
               :checked="autoReloadData.autoReloadType === 'AMOUNT'"/>
        <span>하한선 자동충전</span>
      </label>
      <label class="radiobox">
        <input type="radio" name="autocharging" value="DATE"
               @click="clickRadio($event.target.value)"
               :checked="autoReloadData.autoReloadType === 'DATE'"/>
        <span>월 정액 자동충전</span>
      </label>
    </div>
    <div class="radio-bottom-text px-20" v-show='autoReloadData.autoReloadType === "AMOUNT"'>
      <div class="autocharging-precautions p-reset">
        <ul>
          <li>
            <p><span class="precautions-dot"></span><em>하한선 자동충전은 계산완료 후 카드잔액이 설정한 기준 금액보다 낮아지면 자동충전됩니다.</em></p>
          </li>
          <li>
            <p><span class="precautions-dot"></span><em>하한선 자동충전 설정시 즉시충전 됩니다. (최초설정 1회 限)</em></p>
          </li>
        </ul>
      </div>
      <!-- 첫 하한선 자동충전 설정 시 즉시 충전으로 문구  제거 250423-->
<!--      <p><span></span>잔액이 0원 카드는 하한선 충전이 불가합니다.</p>-->
    </div>
    <div class="radio-bottom-text px-20" v-show='autoReloadData.autoReloadType === "DATE"'>
      <div class="autocharging-precautions p-reset">
        <ul>
          <li>
            <p><span class="precautions-dot"></span><em>월 정액 자동충전은 정해진 충전일에 자동으로 충전금액을 충전합니다.</em></p>
          </li>
        </ul>
      </div>
    </div>
    <div class="mb-32 px-20">
      <div class="mb-24 pt-10" v-show='autoReloadData.autoReloadType === "DATE"'>
        <strong class="select-reload-notice">자동 충전일</strong>
        <div class="select-board">
          <!--button class="cash-button selected-cash-button" v-for="(item, index) in selectBoardList3" :key="index" @click="autoReloadDataArray(item.day)">{{item.price}}</button-->
          <button class="date-button" id="DATE_01" @click="selectDate('01', $event)">매월 1일</button>
          <button class="date-button" id="DATE_05" @click="selectDate('05', $event)">매월 5일</button>
          <button class="date-button" id="DATE_10" @click="selectDate('10', $event)">매월 10일</button>
          <button class="date-button" id="DATE_15" @click="selectDate('15', $event)">매월 15일</button>
          <button class="date-button" id="DATE_20" @click="selectDate('20', $event)">매월 20일</button>
          <button class="date-button" id="DATE_25" @click="selectDate('25', $event)">매월 25일</button>
          <button class="date-button" id="DATE_ED" @click="selectDate('ED', $event)">매월 말일</button>
        </div>
      </div>
      <div class="mb-24 pt-10" v-show='autoReloadData.autoReloadType === "AMOUNT"'>
        <strong class="select-reload-notice">기준 잔액</strong>
        <div class="select-board">
          <button class="based-cash-button" id="BASED_AMOUNT_W10K" @click="selectAmount('autoReloadBasedAmount', 'W10K', $event)">1만원</button>
          <button class="based-cash-button" id="BASED_AMOUNT_W20K" @click="selectAmount('autoReloadBasedAmount', 'W20K', $event)">2만원</button>
          <button class="based-cash-button" id="BASED_AMOUNT_W30K" @click="selectAmount('autoReloadBasedAmount', 'W30K', $event)">3만원</button>
          <button class="based-cash-button" id="BASED_AMOUNT_W50K" @click="selectAmount('autoReloadBasedAmount', 'W50K', $event)">5만원</button>
          <button class="based-cash-button" id="BASED_AMOUNT_W100K" @click="selectAmount('autoReloadBasedAmount', 'W100K', $event)">10만원</button>
        </div>
      </div>
      <div class="mb-24">
        <strong class="select-reload-notice">자동 충전 금액</strong>
        <div class="select-board select-button-box">
          <button class="cash-button" id="AMOUNT_W10K" @click="selectAmount('autoReloadAmount', 'W10K', $event, 10000)">1만원<badge v-if="applyMinAmount && applyMinAmount <= 10000" :color="'red'" :text="'추가혜택'"></badge></button>
          <button class="cash-button" id="AMOUNT_W20K" @click="selectAmount('autoReloadAmount', 'W20K', $event, 20000)">2만원<badge v-if="applyMinAmount && applyMinAmount <= 20000" :color="'red'" :text="'추가혜택'"></badge></button>
          <button class="cash-button" id="AMOUNT_W30K" @click="selectAmount('autoReloadAmount', 'W30K', $event, 30000)">3만원<badge v-if="applyMinAmount && applyMinAmount <= 30000" :color="'red'" :text="'추가혜택'"></badge></button>
          <button class="cash-button" id="AMOUNT_W50K" @click="selectAmount('autoReloadAmount', 'W50K', $event, 50000)">5만원<badge v-if="applyMinAmount && applyMinAmount <= 50000" :color="'red'" :text="'추가혜택'"></badge></button>
          <button class="cash-button" id="AMOUNT_W100K" @click="selectAmount('autoReloadAmount', 'W100K', $event, 100000)">10만원<badge v-if="applyMinAmount && applyMinAmount <= 100000" :color="'red'" :text="'추가혜택'"></badge></button>
          <button class="cash-button" id="AMOUNT_WETC" @click="selectAutoReloadAmount($event)" @blur="checkAutoReloadAmount()">직접입력</button>
          <input type="text" maxlength="6" v-if="isOtherAmount" placeholder="원" name="isOtherAmount"
                 ref="otherReloadAmount"
                 @input="selectAutoReloadAmountBind($event)"
                 @blur="checkAutoReloadAmount()"
                 :value="otherReloadAmount"
                 oninput="this.value = this.value.replace(/[^0-9]/ig, '')"
          >
          <template v-if="showBenefitAmountNotice">
            <bg-gray-text style="margin: 1.25rem 0 0 0;" :text="`${benefitAmountNotice} 됩니다`"></bg-gray-text>
            <p style="font-size: 0.8125rem;line-height: 1.3125rem; font-weight: 400; letter-spacing: -0.65px;">※ 추가 충전은 중단될 수 있으며 사전에 고지합니다</p>
          </template>
          <div ref="amountAlertBox" style="margin-left: auto; visibility:hidden">
            <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="금액 입력 오류">
            <span ref="amountAlertMessage" class="amountAlertMessageBox"></span>
          </div>
        </div>
      </div>
    </div>
    <gray-line class="absolute"></gray-line>
    <!-- 결제 방법 -->
    <div class="pt-32 pb-32 px-20">
      <subject-text class="subject-text mb-16" text="결제 방법"></subject-text>

      <div class="pay-button-wrap">
        <button type="button" ref="payButton" :class="{'active' : autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'}" @click.prevent="clickPayToolCode('ACCOUNT_TRANSFER')">
          퀵계좌이체
          <badge v-if="accountTransferBenefit" :color="'blue'" :text="formattedPrice(accountTransferBenefit.applyMinAmount) + getBenefitGuide(accountTransferBenefit)"></badge>
        </button>
        <button type="button" ref="payButton" :class="{'active' : autoReloadData.autoReloadPayToolCode === 'CARD'}"  @click.prevent="clickPayToolCode('CARD')">
          신용·체크카드
          <badge v-if="cardBenefit" :color="'blue'" :text="formattedPrice(cardBenefit.applyMinAmount) + getBenefitGuide(cardBenefit)"></badge>
        </button>
      </div>
      <!-- 퀵계좌이체 -->
      <template v-if="autoReloadData.autoReloadPayToolCode==='ACCOUNT_TRANSFER'">

        <!-- 계좌 미등록 상태의 경우 -->
        <div v-if="!autoReloadData.quickAccountTransferBillkey" class="account-precautions mb-16" >
          <ul>
            <li>
              <p><span class="precautions-dot"></span><em>퀵 계좌이체 사용시, 계좌 등록이 필요합니다.</em></p>
            </li>
          </ul>
        </div>

        <!-- 계좌 등록 상태인 경우 -->
        <payment-account class="mb-20" :key="autoReloadData.quickAccountTransferBillkey" :auto-reload-data="autoReloadData" :auto-reload-card-info="cardInfo"></payment-account>

        <div class="account-precautions">
          <div>
            <strong>퀵 계좌이체 혜택 안내</strong>
          </div>
          <ul>
            <li v-if="accountTransferBenefit">
              <p><span class="precautions-dot"></span><em>{{formattedPrice(accountTransferBenefit.applyMinAmount)}} 자동충전시 {{getBenefitGuide(accountTransferBenefit)}} 충전됩니다. </em></p>
            </li>
<!--            <li>-->
<!--              <p><span class="precautions-dot"></span><em>결제시 0.3% 즉시 할인됩니다. (결제금액 무관)</em></p>-->
<!--            </li>-->
          </ul>
        </div>
      </template>
      <!-- 신용·체크카드 -->
      <template v-if="autoReloadData.autoReloadPayToolCode==='CARD'">
        <div class="paycard">
          <div>
            <swiper :options="swiperOptions" ref="swiper" @slideChange="slideChange()">
              <swiper-slide v-for="(item, index) in cardList" :key="`card_${index}`">
                <div style="position: relative; text-align: center;">
                  <div style="position: relative; min-width: rem(270); max-width: rem(270); height: 100%; box-sizing: border-box;">
                    <img v-if="item.methodKey" :src="item.iconUrl" alt="" @click="brandpayCard(item.methodKey)"/>
                    <img v-else src="@/assets/images/products/addpaycard.png" alt="" style="width: 100%; height: 100%;" @click="brandpayCard(item.methodKey)"/>
                  </div>
                  <p v-if="item.methodKey">
                    {{item.issueCodeName}} <br> {{item.cardName}} <br> {{item.cardNumber}}
                  </p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </template>
<!--        <div class="mt-40">-->
<!--        </div>-->
    </div>
    <gray-line class="absolute"></gray-line>
    <div class="autocharging-precautions">
      <div>
        <span class="icon-tool-tip"></span>
        <strong style="padding-bottom: 0;">이마티콘 자동 충전 유의사항</strong>
      </div>
      <ul>
        <li>
          <p><span class="precautions-dot"></span><em>하한선 자동충전 설정시 즉시충전 됩니다. (최초설정 1회 限)</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>카드 분실 신고 시 자동 충전 설정은 즉시 자동 해제됩니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>월 정액 자동충전시 당일 오전 10시부터 순차적으로 충전 진행됩니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>다음의 경우에 자동 충전 설정은 자동으로 해제됩니다.</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>자동 충전에 의해 결제시도 시, 연속으로 2회 이상 카드사나 통신사 측의 승인이 거부되는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>사용중인 카드를 등록해지하는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>분실, 고장 등의 사유로 자동 충전 설정이 된 카드를 중지 신청하는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>회원탈퇴로 이마티콘 서비스를 더 이상 이용하지 않는 경우</em></p>
        </li>
        <li>
          <p class="ml-11"><span class="precautions-dash">- </span><em>충전 이후 사용 이력이 없는 경우 온라인에서 구매/충전 취소가 가능합니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>이마티콘 충전시 기존 잔액 + 충전금액 합계가 50만원이 초과되는 경우 충전이 되지 않습니다.</em></p>
        </li>
        <li v-if="setPrecautionsEnable()">
          <p><span class="precautions-dot"></span><em>이마티콘은 월 최대 500만원 구매 가능합니다.<br>
            (구매/선물/충전/자동충전 합산액 기준)<br>
            매월 1일에 구매 가능 한도가 자동 복원됩니다.</em></p>
        </li>
        <li>
          <p><span class="precautions-dot"></span><em>충전시 제공되는 혜택은 운영 정책에 따라 변경될 수 있습니다.</em></p>
        </li>
      </ul>
    </div>
    <div class="autocharging-button-wrap absolute bottom-sticky">
      <div class="button-wrap">
        <button @click="clickBtn()"
                :class="saveBtnDisabled ? 'button-disabled' : 'button-bg-yellow'"
                style="border-radius: 0;"
                :disabled="saveBtnDisabled">저장하기</button>
      </div>
      <!--            <bottom-button @sendEvent="clickBtn()" class="button-style" :buttonArray="buttonArray"></bottom-button>-->
    </div>
    <!--div class="autocharging-precautions">
      <div class="button-wrap">
        <button @click="clickRequestAgreeBtn()" class="button-bg-yellow round">약관동의</button>
      </div>
    </div-->
    <alert-popup v-if="showCenterPopup" @confirmPopupClickConfirm="closeCenterPopup()" :message="centerPopupMsg"></alert-popup>
    <charging-popup2 v-if="showBtmPopup" @emitPopValue="showBtmPopup = false" :message="btmMsg" />
  </div>
</template>

<script>
import GrayLine from '@/components/common/GrayLine.vue';
import SelectPayment from '@/components/common/SelectPayment.vue';
import SubjectText from '@/components/common/SubjectText.vue';
import PaymentCard from '@/components/common/PaymentCard.vue'
import PaymentAccount from '@/components/common/PaymentAccount.vue';
import AlertPopup from './chargingAlertPopup.vue';
import ChargingPopup2 from "@/views/cards/chargingPopup2.vue";
import Badge from '@/components/common/Badge.vue';
import BgGrayText from '@/components/common/BgGrayText.vue';
import apiList from "@/api/apiList";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import dayjs from "dayjs";

let brandpay = ''           // 브랜드페이
let selectedDateCount = 1;  // 일자지정 시 최대 선택 갯수 - 현재 1개
export default {
  name: 'AutoCharging',
  components: { GrayLine, SelectPayment, SubjectText, PaymentCard, PaymentAccount, Swiper, SwiperSlide, AlertPopup, ChargingPopup2, Badge, BgGrayText},
  data() {
    // selectBoardList: <select-board></select-board> 컴포넌트에게 전달할 프롭스
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        // loop: true
      },
      interestFreeMonthList: [
        {value:'0', name:'일시불(5만원 이상 할부 가능)'},
        {value:'2', name:'2개월'},
        {value:'3', name:'3개월'},
        {value:'4', name:'4개월'},
        {value:'5', name:'5개월'},
        {value:'6', name:'6개월'},
        {value:'7', name:'7개월'},
        {value:'8', name:'8개월'},
        {value:'9', name:'9개월'},
        {value:'10', name:'10개월'},
        {value:'11', name:'11개월'},
        {value:'12', name:'12개월'}
      ],
      billing: '',      // 자동결제 약관동의 여부
      code: '',         // PG사 임시코드
      cardList: [],
      cardIndex: '',                // 선택한 카드의 index
      cardPromotion: {              // 카드혜택
        discountCards: [],          // 카드사별 할인정책 정보
        interestFreeCards: [],      // 카드사별 무이자할부개월 정보
        pointCards: []              // 카드사별 포인트 사용 정보
      },
      autoReloadData: { // 자동충전 설정 조회
        prepaidCardNo: '', // 선불카드번호
        billKey: '', // 빌키
        autoReloadType: '', // 자동충전유형
        autoReloadAmountType: '', // 자동충전금액유형
        autoReloadAmount: '', // 자동충전금액 > 직접 입력 선택 시 활성화
        autoReloadBasedAmountType: '', // 자동충전기준금액유형
        autoReloadDay: [], // 자동충전일자(2개 선택가능)
        autoReloadPayToolCode: '', // 자동충전결제수단코드
        autoReloadChangeDateTime: '',
        autoReload: '',
        giftMessage: '',
        issueDate: '',
        remainCash: '',
        actionType: '',
        installmentFreeMonth: '',
        billingAgreementDateTime: '',
        bankName: '', // 퀵계좌이체 은행명
        bankAccountNumber: '', // 퀵계좌이체 마스킹된 계좌번호
        quickAccountTransferBillkey: '' // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리(실제 업로드 시 methodKey 사용)
      },
      otherReloadAmount: '', // 자동충전금액 직접입력 선택 시 처리
      prepaidCardNo: '',
      methodKey: '', // 빌키
      clientKey: this.$store.state.autoReloadClientKey, // 클라이언트 키 <- 위젯에서 브랜드페이 테스트키로 전달받는 키 <-23/12/19 전달받은 키와 동일
      customerKey: this.$store.state.mberInfo.mberNo, // 'C21743839' 내 상점에서 고객을 구분하기 위해 발급한 고객의 고유 ID
      mberNo: this.$store.state.mberInfo.mberNo,
      pgCode: this.$store.state.autoReloadPgCode,
      showCenterPopup: false,
      centerPopupMsg: '', // 중앙 alert 팝업에 보여줄 메시지
      showBtmPopup: false,
      btmMsg: '', // 하단 alert 팝업에 보여줄 메시지
      cardInfo: {}, // params로 넘어오는 카드 정보
      installmentFreeMonth: '',        // 임시 할부개월 수
      billingAgreementDateTime: '',    // 자동약관동의일시
      isOtherAmount: false, // 직접입력 tag 사용 여부
      // badgeText: '',
      // badgeColor:'',
      applyMinAmount: 0,
      benefitAmountNotice: '',
      showBenefitAmountNotice: false,
      cardBenefit: {}, // 카드 혜택(자동충전)
      accountTransferBenefit: {}, // 계좌이체 혜택(자동충전)
    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  computed: {
    /**
     * 카드 할부정보 셀렉트박스 enabled/disabled 처리
     */
    setDisabledInstallmentMonth() {
      const cardInfo = this.cardList[this.cardIndex];

      // 1. 기존 무이자 할부 정보 지우기
      for(var j = 1; j < this.interestFreeMonthList.length; j++) {
        this.interestFreeMonthList[j].name = this.interestFreeMonthList[j].value + "개월";
      }

      // 2. 결제수단의 카드사 무이자 할부 정보 설정
      // 2-1. 현재 선택한 결제수단 카드사의 무이자 할부 혜택정보 존재여부 체크
      var bTrue = true;
      const interestFreeCards = this.cardPromotion.interestFreeCards;
      var selIndex = -1;
      for(var i = 0; i < interestFreeCards.length; i++) {
        const interestFreeCard = interestFreeCards[i];
        //console.log("acquirerCode[" + cardInfo.acquirerCode + "]companyCode[" + interestFreeCard.companyCode +"]");
        if(cardInfo.acquirerCode === interestFreeCard.companyCode) {
          bTrue = false;
          selIndex = i;
          break;
        }
      }
      // 2-2. 선택한 결제수단 카드사의 무이자 할부 혜택이 존재 시 처리
      //  - 무이자 할부 기간을 선택하여 '무이자 할부' 정보를 Text로 노출
      if(!bTrue) {
        /* const interestFreeMonth = document.querySelector("brandpay-select-area"); */
        for(var i = 0; i < interestFreeCards[selIndex].installmentFreeMonths.length; i++) {
          //console.log("interestFreeCards[" + selIndex + "].installmentFreeMonths[" + i + "]" + interestFreeCards[selIndex].installmentFreeMonths[i]);
          for(var j = 0; j < this.interestFreeMonthList.length; j++) {
            if(this.interestFreeMonthList[j].value === interestFreeCards[selIndex].installmentFreeMonths[i]) {
              this.interestFreeMonthList[j].name = interestFreeCards[selIndex].installmentFreeMonths[i] + "개월 무이자할부";
            }
          }
        }
      }

      // 3. 선택한 결제수단이 비활성화(해지) 상태인 경우 할부개월 선택 콤보 비활성화 처리
      //  - 결제수단 조회 시 비활성화(해지) 결제수단은 조회되지 않으나 체크를 위해 추가
      if(cardInfo.staus === "DISABLED") {
        return true;
      }

      // 4. 자동충전금액타입에 따른 실금액 설정
      //  - 기타금액일 경우 설정정보에 저장된 자동충전금액을 사용
      var autoReloadAmount = this.autoReloadData.autoReloadAmount;
      if(this.autoReloadData.autoReloadAmountType === "W10K") {
        autoReloadAmount = 10000;
      }
      else if(this.autoReloadData.autoReloadAmountType === "W20K") {
        autoReloadAmount = 20000;
      }
      else if(this.autoReloadData.autoReloadAmountType === "W30K") {
        autoReloadAmount = 30000;
      }
      else if(this.autoReloadData.autoReloadAmountType === "W50K") {
        autoReloadAmount = 50000;
      }
      else if(this.autoReloadData.autoReloadAmountType === "W100K") {
        autoReloadAmount = 100000;
      }

      // 5. 자동충전금액이 5만원 이하일 경우 일시불로 변경 후 콤보박스 비활성화 처리
      // QA-4266 자동 충전 금액이 5만원 이상인 경우, 결제수단 선택 영역에 할부 기간이 선택이 가능
      //if(autoReloadAmount < parseInt(cardInfo.installmentMinimumAmount)) {
      if(autoReloadAmount < 50000) {
        // 할부가 불가능하면 일시불로 변경 처리
        this.installmentFreeMonth = 0;
        return true;
      }
      //console.log("autoReloadAmount: " + autoReloadAmount);

      return false;
    },
    /**
     * 저장하기 버튼 비활성화 처리
     */
    saveBtnDisabled () {
      // 1. 자동충전유형이 하한선(금액)일 경우 기준금액이 선택되지 않으면 저장버튼 비활성화 처리
      if (this.autoReloadData.autoReloadType === 'AMOUNT') {
        if (!this.autoReloadData.autoReloadBasedAmountType || this.autoReloadData.autoReloadBasedAmountType === 'NONE') {
          return true
        }
      }
      // 2. 자동충전유형이 월 정기(일자)일 경우 충전일자가 선택되지 않으면 저장버튼 비활성화 처리
      if (this.autoReloadData.autoReloadType === 'DATE') {
        if (!this.autoReloadData.autoReloadDay || this.autoReloadData.autoReloadDay.length === 0) {
          return true
        }
      }
      // 3. 자동충전금액이 선택되지 않으면 저장버튼 비활성화 처리
      if (!this.autoReloadData.autoReloadAmountType || this.autoReloadData.autoReloadAmountType === 'NONE') {
        return true
      }
      // 4. 자동충전금액이 직접입력이나 금액이 입력되지 않으면 비활성화 처리
      if (this.autoReloadData.autoReloadAmountType === 'WETC' && !this.autoReloadData.autoReloadAmount) {
        return true
      }
      // 5. 결제수단이 선택되지 않으면 비활성화 처리
      if (!this.methodKey) {
        return true
      }
      return false
    },
  },
  watch: {
  },

  /**
   * mounted
   */
  mounted() {
    // 1. 헤더 설정
    this.$heading('자동충전');

    // 2. prepaidCardNo가 없다면 에러페이지로 이동
    // 2-1. 선불카드(이마티콘) 정보가 정상적으로 전달되면 자동충전설정 정보 조회
    // 2-2. 선불카드(이마티콘) 정보가 누락되었다면 에러페이지 이동 처리
    let cardInfo = '';

    if(this.$route.params.cardInfo) {
      cardInfo = this.$route.params.cardInfo;
    } else {

      // 퀵계좌이체 등록 화면에서 돌아오면 히스토리 조작
      if (sessionStorage.getItem('RegisterQuickAccountTransferHistory') === 'true') {
        sessionStorage.removeItem('RegisterQuickAccountTransferHistory');
        window.history.pushState(null, null, window.location.href);
      }

      // 퀵계좌이체 계좌등록 후 데이터 세팅
      cardInfo = this.$store.state.autoReloadCardInfo;
      this.autoReloadData = this.$store.state.autoReloadData;

      // 퀵계좌이체 등록 성공
      if(this.$route.query.customerKey && this.$route.query.authKey) {
        // 퀵계좌이체 빌링키 발급
        this.postAccountTransferBillingKey(this.$route.query.customerKey, this.$route.query.authKey);
      } else {
        // 퀵계좌이체 등록 실패 또는 취소 시 메시지 처리
        this.$route.query.message ? this.openCenterPopup(this.$route.query.message) : false;
      }
      // 퀵계좌이체 등록 화면에서 다시 돌아오면 데이터 초기화
      this.$store.commit("setAutoReloadCard", {autoReloadData: null, autoReloadCardInfo: null});

    }

    if (cardInfo && cardInfo.prepaidCardNo) {
      this.cardInfo = cardInfo
      this.prepaidCardNo = cardInfo.prepaidCardNo;
      this.$route.params.cardInfo? this.getAutoReload() : undefined; //params로 데이터가 넘어온 경우 자동충전설정 정보 조회
    } else {
      const errorPath = '/error'
      if (this.$route.path !== errorPath) {
        this.$router.replace({path: "/error"});
      }
      return;
    }

    // 3. 브랜드페이 초기화 처리
    //console.log("brandpay");
    brandpay = BrandPay(this.clientKey, this.customerKey, {
      // redirectUrl: 'http://localhost:8080/api/v1.0.0/prepaid/pg-redirect-url',
      redirectUrl: `${process.env.VUE_APP_BACK_BASE_URL}/v1.0.0/prepaid-card/redirect-url`,
      ui: {
        buttonStyle: 'full',
        highlightColor: '#26C2E3',
        labels: {
          oneTouchPay: '내 상점 원터치결제',
        },
      },
    })

    this.getPrepaidCardReloadBenefits()
  },
  methods: {
    async getPrepaidCardReloadBenefits() {
      const res = await apiList.getAutoReloadBenefits(); // 선불카드 자동 충전 혜택 정보 조회
      const reloadBenefit = res.data.data.filter(el => !el.payToolCode)[0];
      if (reloadBenefit) {
        switch(reloadBenefit.conditionKey) {
          case 'FIXED_RATE_EXTRA_CHARGE': // %
            this.benefitAmountNotice = reloadBenefit.conditionValue + '% 추가 충전';
            break;
          case 'FLAT_EXTRA_CHARGE': // 원
            this.benefitAmountNotice = reloadBenefit.conditionValue + '원 추가 충전';
            break;
          case 'FIXED_RATE_DISCOUNT': // %
            this.benefitAmountNotice = reloadBenefit.conditionValue + '% 할인 결제';
            break;
          case 'FLAT_DISCOUNT':
            this.benefitAmountNotice = reloadBenefit.conditionValue + '원 할인 결제';
            break;
        }
        this.applyMinAmount = reloadBenefit.applyMinAmount;
        if(this.applyMinAmount <= 10000) {
          this.showBenefitAmountNotice = true;
        }
      }
      // 결제 수단에 따른 혜택 조회
      const benefits = res.data.data;
      if(benefits.length > 0) {
        this.paymentMethodBenefits(benefits)
      }

    },
    /**
     * 할부기간 변경 처리
     *  - 사용하지 않음
     */
    changeInstallmentMonth() {
      // 추후 변경사항 입력
    },

    /**
     * 자동충전설정일자 데이터 배열
     *  - 사용하지 않음.
     * @param item 자동충전설정일자
     */
    autoReloadDataArray(item) {
      if (!this.autoReloadData.autoReloadDay) {
        this.autoReloadData.autoReloadDay = []
      }
      if (this.autoReloadData.autoReloadDay.length === 0) {
        this.autoReloadData.autoReloadDay.push(item)
      } else {
        if (this.autoReloadData.autoReloadDay.indexOf(item) === -1) { // autoReloadDay 에 이미 들어가있는 값이면 추가되지 않음.
          this.autoReloadData.autoReloadDay.push(item)
          if (this.autoReloadData.autoReloadDay.length > 2) { // length 가 2이상이면 뒤 2개 값만 남김.
            this.autoReloadData.autoReloadDay = this.autoReloadData.autoReloadDay.slice(-2)
          }
        }
      }
    },

    /**
     * 일자 클릭 시 해당일자를 충전일자에 바인딩
     * @param {EnumType} selectDate 선택한 충전일자(ED.매월 말일)
     * @param {Object} e 해당 태그의 event
     */
    selectDate(selectDate, e) {
      // selectedDateCount <- 충전일자 최대 갯수
      // 1. 조회된 충전일자가 존재하지 않으면 충전일자 초기화 처리
      if (!this.autoReloadData.autoReloadDay) {
        this.autoReloadData.autoReloadDay = []
      }

      // 2. 충전일자 선택 처리
      // 2-1. 선택한 충전일자가 빈값일 경우 선택한 값을 입력
      if (this.autoReloadData.autoReloadDay.length === 0) {
        this.autoReloadData.autoReloadDay.push(selectDate)
      }
      // 2-2. 선택한 충전일자를 배열에 설정
      else {
        // 2-2-1. autoReloadDay 에 이미 들어가있는 값이면 추가되지 않음.
        if (this.autoReloadData.autoReloadDay.indexOf(selectDate) === -1) {
          this.autoReloadData.autoReloadDay.push(selectDate)
        }

        // 2-2-2. 선택한 일자의 갯수가 selectedDateCount보다 큰 경우 나중에 입력한 selectedDateCount개의 값만 남김.
        if (this.autoReloadData.autoReloadDay.length > selectedDateCount) { // length 가 2이상이면 뒤 2개 값만 남김.
          this.autoReloadData.autoReloadDay = this.autoReloadData.autoReloadDay.slice(-selectedDateCount)
        }
      }

      // 3. 선택한 버튼에 대한 class 설정
      const buttons = document.querySelectorAll('.date-button');
      buttons.forEach(btn => {
        if( btn.classList.contains('active')) {
          const dateVal = btn.id.replace("DATE_", "");
          if (this.autoReloadData.autoReloadDay.indexOf(dateVal) === -1) {
            btn.classList.remove('active')
          }
        }
      });
      // 이벤트가 발생한 태그에 active 클래스 부여
      e.target.classList.add('active');
    },
    /**
     * 자동충전유형 라디오버튼 click
     * @param value 선택한 자동충전유형 값
     */
    clickRadio(value) {
      this.autoReloadData.autoReloadType = value

      // 하한선 자동충전
      if (value === 'AMOUNT') {
        // 자동충전일 초기화
        this.autoReloadData.autoReloadDay = []
        // 자동충전일 buttons를 순회하며 active 클래스가 있는지 체크 후 있으면 제거
        this.removeActive('.date-button')
      }

      // 월 정액 자동충전
      if (value === 'DATE') {
        // 기준잔액 초기화
        this.autoReloadData.autoReloadBasedAmountType = 'NONE'
        // 기준잔액 buttons를 순회하며 active 클래스가 있는지 체크 후 있으면 제거
        this.removeActive('.based-cash-button')
      }

      // 자동충전금액 초기화
      this.autoReloadData.autoReloadAmountType = ''
      this.otherReloadAmount = ''

      // 자동충전금액 - 추가충전 문구 노출 안되도록.
      this.showBenefitAmountNotice = false;

      // 자동충전금액 - 직접입력 input 노출 안되도록.
      this.isOtherAmount = false;

      // 자동충전금액 - 경고 아이콘 / 문구 노출 안되도록.
      this.$refs.amountAlertBox.style.visibility = 'hidden';
      this.$refs.amountAlertMessage.innerHTML = ''

      // 자동충전금액 buttons를 순회하며 active 클래스가 있는지 체크 후 있으면 제거
      this.removeActive('.cash-button')
    },
    removeActive (sel) { // buttons를 순회하며 active 클래스가 있는지 체크 후 있으면 제거
      let cashButtons = document.querySelectorAll(sel);
      cashButtons.forEach(btn => {
        if( btn.classList.contains('active')) {
          btn.classList.remove('active')
        }
      });
    },
    /**
     * 금액 버튼 클릭시 해당 금액을 payAmount에 바인딩하는 메소드
     * @param {EnumType} selectedAmountType 선택한 충전 금액의 유형
     * @param {Object} e 해당 태그의 event
     */
    selectAmount(colNm, selectReloadAmountType, e, selectedAmount){
      // 직접입력 tag 사용여부 false
      this.isOtherAmount = false;
      // 1. 경고 아이콘 hidden
      this.$refs.amountAlertBox.style.visibility = 'hidden';
      // 2. 경고문구 제거
      this.$refs.amountAlertMessage.innerHTML = ''
      // 3. 충전금액 직접입력란 유효성 검증 통과 처리
      this.isCheckOtherAmount = true;

      // 4. cash-button 클래스를 가진 노드 조회
      var selector = ''
      if(colNm === 'autoReloadBasedAmount') {
        selector = 'based-'
      }

      const buttons = document.querySelectorAll('.' + selector + 'cash-button');
      // 5. buttons를 순회하며 active 클래스가 있는지 체크 후 있으면 제거
      buttons.forEach(btn => {
        if( btn.classList.contains('active')){
          btn.classList.remove('active')
        }
      });
      // 6. 이벤트가 발생한 태그에 active 클래스 부여
      e.target.classList.add('active');

      // 추가충전 문구 노출 여부 세팅 - 자동 충전 금액 항목 클릭시에만 실행.
      if (colNm === 'autoReloadAmount') {
        if (this.applyMinAmount && (this.applyMinAmount <= selectedAmount)) {
          this.showBenefitAmountNotice = true;
        } else {
          this.showBenefitAmountNotice = false;
        }
      }

      // 7. 결제금액 바인딩
      if(colNm === 'autoReloadAmount') {
        this.autoReloadData.autoReloadAmountType = selectReloadAmountType;
        // 직접 입력한 충전 금액은 ''(공백)으로 초기화
        this.autoReloadData.autoReloadAmount = '';
        this.otherReloadAmount = '';
      }
      else if(colNm === 'autoReloadBasedAmount') {
        this.autoReloadData.autoReloadBasedAmountType = selectReloadAmountType;
      }
    },
    /**
     * 충전금액 직접입력 선택시 해당 금액을 payAmount에 바인딩하는 메소드
     * @param {Object} e 해당 태그의 event
     */
    selectAutoReloadAmount(e) {
      // 직접입력 tag 사용여부 false
      this.isOtherAmount = true;

      this.autoReloadData.autoReloadAmountType = 'WETC'
      // 1. 충전금액 직접입력란 유효성 검증 false 처리
      this.isCheckOtherAmount = false;
      // 2. 선택한 금액은 0으로 초기화
      this.otherReloadAmount = '';
      this.autoReloadData.autoReloadAmount = 0;

      // 3. cash-button 클래스를 가진 노드 조회
      const buttons = document.querySelectorAll('.cash-button');
      // 4. buttons를 순회하며 active 클래스가 있는지 체크 후 있으면 제거
      buttons.forEach(btn => {
        if (btn.classList.contains('active')) {
          btn.classList.remove('active')
        }
      });
      // 5. 직접입력 태그에 active 클래스 부여
      e.target.classList.add('active');
      // 추가혜택 텍스트 노출 여부 초기화
      this.showBenefitAmountNotice = false;
    },
    /**
     * 자동충전 금액 클릭 이벤트
     *  - 사용하지 않음
     * @param type 자동충전금액 유형 코드
     */
    amountEvent(type) { // 자동 충전 금액 클릭 이벤트
      this.autoReloadData.autoReloadAmountType = type
      if (this.autoReloadData.autoReloadAmountType !== 'WETC') {
        this.autoReloadData.autoReloadAmount = ''
      }
    },
    /**
     * 충전금액을 직접 입력할때 데이터 바인딩 메소드
     * @param e 해당 태그의 event
     */
    selectAutoReloadAmountBind(e){
      // 1. 기타금액에 입력한 값을 저장
      this.otherReloadAmount = e.target.value;
    },
    /**
     * 직접입력한 금액에 대한 유효성 검증
     */
    checkAutoReloadAmount(){
      // 미입력 검증
      if(!this.otherReloadAmount){
        this.otherReloadAmount = '';
        this.autoReloadData.autoReloadAmount = 0;
        this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '금액을 입력해주세요.';
        return;
      }else{
        this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
      }

      // 1. 숫자 여부 검증
      //  - 콤마(,) 제거 정규식을 사용하지 않으면 10,000원 입력 후 추가로 0을 붙이면 오류(isNaN) 발생하게됨
      let autoReloadAmount = Number(this.otherReloadAmount.replace(/\D/g,''));
      //console.log("autoReloadAmount : " + autoReloadAmount)
      if(isNaN(autoReloadAmount)){
        this.autoReloadData.autoReloadAmount = 0;
        this.otherReloadAmount = '';
        this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '숫자만 입력 가능합니다.';
        //this.showBtmPopup = true
        //this.btmMsg = `숫자만 입력 가능합니다.`
        return;
      } else{
        this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
      }

      // 2. 소수점 이하 버리기
      autoReloadAmount = Math.floor(autoReloadAmount);

      // 3. 최소 금액 만족 여부 체크 (1만원 이상)
      // 24.01.22 최소 금액 변경 (10,000원 -> 10원)
      // 24.01.25 최소 금액 변경 (10원 -> 10,000원)
      if(autoReloadAmount < 10000){
        this.autoReloadData.autoReloadAmount = 0;
        this.otherReloadAmount = '';
        this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '최소 구매 금액은 1만원 입니다.';
        return;
      } else{
        this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
      }

      // 4. 최대 금액 만족 여부 체크 (49만원 이하만 구매 가능)
      if(autoReloadAmount > 490000){
        this.autoReloadData.autoReloadAmount = 0;
        this.otherReloadAmount = '';
        this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '최대 구매 금액은 49만원 입니다.';
        //this.showBtmPopup = true
        //this.btmMsg = `최대 구매 금액은 49만원 입니다.`
        return;
      } else {
        this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
      }

      // 5. 1만원 단위의 금액을 입력했는지 체크
      // 24.01.22 구매 금액 단위 변경 (10,000원 -> 10원)
      // 24.01.25 구매 금액 단위 변경 (10원 -> 10,000원)
      if (autoReloadAmount % 10000 !== 0){
        this.autoReloadData.autoReloadAmount = 0;
        this.otherReloadAmount = '';
        this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '1만원 단위로 충전이 가능 합니다.';
        return;
      } else {
        this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
      }

      // 직접입력금액 혜택문구 노출 여부 세팅
      if(this.applyMinAmount && (autoReloadAmount >= this.applyMinAmount)) {
        this.showBenefitAmountNotice = true;
      } else {
        this.showBenefitAmountNotice = false;
      }

      // 6. 경고 아이콘 hidden
      this.$refs.amountAlertBox.style.visibility = 'hidden';
      // 7. 경고 문구 제거
      this.$refs.amountAlertMessage.innerHTML = ''
      // 8. 유효성 검증 통과
      this.isCheckOtherAmount = true;
      // 9. autoReloadAmount(자동충전금액) 바인딩
      // this.autoReloadData.autoReloadAmountType = 'WETC';
      this.autoReloadData.autoReloadAmount = this.otherReloadAmount;
      // 10. 직접입력란의 금액에 콤마를 찍어주기 위해서 숫자로 형변환
      this.otherReloadAmount = autoReloadAmount.toLocaleString(); // 천 단위 콤마
    },

    /**
     * 자동충전 결제수단 조회
     */
    async putPaymentMerhods() { // 자동충전 설정 조회
      try {
        // 1. 자동충전 결제수단 조회
        //  - 회원번호, 선불카드(이마티콘) 카드번호로 결제수단 조회
        const response = await apiList.putPaymentMerhods({mberNo: this.mberNo, modifyAuthor: this.mberNo, prepaidCardNo:this.prepaidCardNo});
        // 2. 결제수단 조회 처리
        // 2-1. 조회된 결제수단의 정보를 설정
        //  - 결제수단 카드 정보 설정
        //  - 결제수단 카드 프로모션 정보 설정
        //  - 자동결제 약관 동의 여부 설정
        //  - 선택한 결제수단키를 첫번째 결제수단 키로 설정
        if (response.data.code === 'S00000') {
          this.cardList = response.data.data.cards
          this.cardPromotion = response.data.data.cardPromotion;
          this.billing = response.data.data.billing
          this.code = response.data.data.code

          this.methodKey = this.cardList[0].methodKey;
          this.cardIndex = 0;
        }
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 자동충전설정 정보 조회
     */
    async getAutoReload() { // 자동충전 설정 조회
      try {
        // 1. 선불카드(이마티콘) 번호로 자동충전 설정 정보 조회
        const response = await apiList.getAutoReload({prepaidCardNo: this.prepaidCardNo});
        // 2. 자동충전설정 정보 조회
        if (response.data.code === 'S00000') {

          // 2-1. 자동충전설정 정보 변수에 설정
          this.autoReloadData = response.data.data

          // 2-2. 결제수단 조회(데이터가 없거나 결제수단코드가 CARD면 결제수단조회
          !this.autoReloadData.autoReload || this.autoReloadData.autoReloadPayToolCode === 'CARD' ? await this.putPaymentMerhods() : undefined;

          // 2-3. 데이터가 없는 경우 처리
          if(!this.autoReloadData.autoReload) {
            this.autoReloadData.autoReloadType = 'AMOUNT'
            this.autoReloadData.autoReloadPayToolCode = 'CARD'
            this.autoReloadData.autoReloadDay = []
            this.autoReloadData.autoReloadAmountType = ''
            this.autoReloadData.autoReloadAmount = 0
            this.autoReloadData.autoReloadBasedAmountType = 'NONE'
            this.autoReloadData.autoReloadBasedAmount = ''
            this.autoReloadData.billKey = ''
            this.otherReloadAmount = ''
            this.autoReloadData.installmentFreeMonth = 0
            this.installmentFreeMonth = 0
            this.autoReloadData.billingAgreementDateTime = ''
            this.billingAgreementDateTime = ''
            return;
          } else if(this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER') { // 퀵계좌이체로 등록된 데이터가 있을 경우
            this.autoReloadData.quickAccountTransferBillkey = this.autoReloadData.billKey; // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리
            this.methodKey = this.autoReloadData.billKey; // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리
            this.billing = true; // 약관동의일시여부 체크(퀵계좌이체 이미 등록된 건은 약관동의한 상태)
          }
          // 2-4. 설정한 충전 금액 세팅
          this.setAutoReloadAmount();

        }
        else {
          this.autoReloadData.autoReloadType = 'AMOUNT'
          this.autoReloadData.autoReloadPayToolCode = 'CARD'
          this.autoReloadData.autoReloadDay = []
          this.autoReloadData.autoReloadAmountType = ''
          this.autoReloadData.autoReloadAmount = 0
          this.autoReloadData.autoReloadBasedAmountType = 'NONE'
          this.autoReloadData.autoReloadBasedAmount = ''
          this.autoReloadData.billKey = ''
          this.otherReloadAmount = ''
          this.autoReloadData.installmentFreeMonth = 0
          this.installmentFreeMonth = 0
          this.autoReloadData.billingAgreementDateTime = ''
          this.billingAgreementDateTime = ''
        }
      } catch (error) {
        await this.$router.replace({path: "/error"});
        console.error(error);
      }
      // 3. 할부정보 적용
      this.installmentFreeMonth = this.autoReloadData.installmentFreeMonth;
      // 4. 자동약관 동의 일시 적용
      this.billingAgreementDateTime = this.autoReloadData.billingAgreementDateTime;
    },

    /**
     * 결제수단 스아이퍼 변경 이벤트
     */
    slideChange () { // 스와이퍼 변경 이벤트.
      // 1. 선택한 결제수단의 정보를 결제수단 정보로 설정
      let index = this.$refs.swiper.$swiper.activeIndex
      this.methodKey = this.cardList[index].methodKey
      //console.log("slideChange => " + (this.autoReloadData.billKey === this.methodKey))
      //console.log("slideChange => " + this.autoReloadData.billKey + ":" + this.methodKey)
      // 2. 원 자동충전정보의 결제키와 결제수단이 다르면 일시불로 설정
      //    같으면 해당 정보로 할부정보 설정
      if(this.autoReloadData.billKey !== this.methodKey) {
        this.installmentFreeMonth = '0';
      }
      else {
        this.installmentFreeMonth = this.autoReloadData.installmentFreeMonth;
      }
      this.cardIndex = index;
    },

    /**
     * 결제수단 선택
     * @param mehtodkey 결제수단
     */
    brandpayCard (methodKey) { // 반디페이 res
      // 1. 선택한 결제수단의 값이 없으면 브랜드페이 결제수단 추가(카드) 기능을 실행
      // 1-1. 결제수단을 신규로 등록한 경우 결제수단 목록 재조회 처리
      this.methodKey = methodKey
      let _this = this
      if (!this.methodKey) {
        brandpay.addPaymentMethod('카드')
            .then(function () {
              _this.putPaymentMerhods() // 카드 리스트 재호출
              // 성공 처리
            })
            .catch(function (error) {
              if (error.code === 'USER_CANCEL') {
                // 사용자가 결제창을 닫은 경우 에러 처리
              }
            })
      }
    },


    /**
     * 저장버튼 click
     */
    clickBtn () {
      if(this.mberNo === "C21743839") {
        this.billing = false;
      }

      // 1. 자동결제 동의 체크
      // 1-1. 자동결제 미동의 상태면 브랜드페이의 자동결제 이용약관 동의 요청
      // 1-1-1. 결제동의 후 자동충전설정 저장 처리
      if(!this.billing) {
        let _this = this
        brandpay.requestAgreement('빌링')
            .then(function() {
              _this.billingAgreementDateTime = dayjs().format('YYYY-MM-DD HH:mm:ss'); // 현재날짜 + 시각
              console.log("this.mberNo : " + _this.mberNo + " - billingAgreementDateTime : " + _this.billingAgreementDateTime);
              _this.saveAutoReload();
            })
            .catch(function(error) {
              if(error.code == "USER_CANCEL") {
                //
                console.log("USER_CANCEL");
              }
            })
      }
      // 1-2. 자동결제 동의 상태면 자동충전설정 저장 처리
      else {
        this.saveAutoReload();
      }
    },

    /**
     * 자동설정 저장 처리
     */
    saveAutoReload() {

      // MODIFY 면 자동충전 설정 수정/해지
      // CREATE 면 자동 충전 설정 저장
      if (this.autoReloadData.actionType === 'MODIFY') {
        this.putAutoReload()
      } else if (this.autoReloadData.actionType === 'CREATE') {
        this.postAutoReload()
      }
    },
    /**
     * 자동충전 설정 저장(신규)
     */
    async postAutoReload() { // 자동 충전 설정 저장
      let params = {
        mberNo: this.mberNo,
        prepaidCardNo: this.prepaidCardNo, // 선불카드번호
        pgCode: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? 'accounttransfer' : this.pgCode, // pg코드
        billKey: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.quickAccountTransferBillkey : this.methodKey, // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리
        autoReloadType: this.autoReloadData.autoReloadType, // 자동충전유형
        autoReloadAmountType: this.autoReloadData.autoReloadAmountType, // 자동충전금액유형
        autoReloadAmount: this.autoReloadData.autoReloadAmount, // 자동충전금액 > 직접 입력 선택 시 활성화
        autoReloadBasedAmountType: this.autoReloadData.autoReloadBasedAmountType, // 자동충전기준금액유형
        autoReloadDay: this.autoReloadData.autoReloadDay, // 자동충전일자(2개 선택가능)
        autoReloadPayToolCode: this.autoReloadData.autoReloadPayToolCode, // 자동충전결제수단코드
        installmentFreeMonth: this.installmentFreeMonth,   // 자동충전할부개월 수
        billingAgreementDateTime: this.billingAgreementDateTime,   // 자동충전약관 동의일시
        initAuthor: this.mberNo, // 등록자
        modifyAuthor: this.mberNo, // 수정자 (등록자와 동일)
        bankName: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.bankName : null, //퀵계좌이체 - 은행명
        bankAccountNumber: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.bankAccountNumber : null//퀵계좌이체 - 계좌번호(기본 중간 5자리 마스킹)
      }
      try {
        const response = await apiList.postAutoReload({...params});
        if (response.data.code === 'S00000') {
          this.openCenterPopup('저장 되었습니다.')
        }
      } catch (error) {
        this.showBtmPopup = true
        this.btmMsg = `저장 실패했습니다.`
        console.log(error.response)
      }
    },
    /**
     * 자동충전설정 수정 처리
     */
    async putAutoReload() { // 자동충전 설정 수정/해지
      let params = {
        actionType: 'MODIFY', // 수정/해지 구분 (MODIFY : 수정, TRMNT: 해지)
        mberNo: this.mberNo,
        pgCode: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? 'accounttransfer' : this.pgCode, // pg코드
        billKey: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.quickAccountTransferBillkey : this.methodKey, // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리
        autoReloadType: this.autoReloadData.autoReloadType, // 자동충전유형
        autoReloadAmountType: this.autoReloadData.autoReloadAmountType, // 자동충전금액유형
        autoReloadAmount: this.autoReloadData.autoReloadAmount, // 자동충전금액 > 직접 입력 선택 시 활성화
        autoReloadBasedAmountType: this.autoReloadData.autoReloadBasedAmountType, // 자동충전기준금액유형
        autoReloadDay: this.autoReloadData.autoReloadDay, // 자동충전일자(2개 선택가능)
        autoReloadPayToolCode: this.autoReloadData.autoReloadPayToolCode, // 자동충전결제수단코드
        installmentFreeMonth: this.installmentFreeMonth,   // 자동충전할부개월 수
        billingAgreementDateTime: this.billingAgreementDateTime,   // 자동충전약관 동의일시
        modifyAuthor: this.mberNo, // 수정자 (등록자와 동일)
        bankName: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.bankName : null, //퀵계좌이체 - 은행명
        bankAccountNumber: this.autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.bankAccountNumber : null//퀵계좌이체 - 계좌번호(기본 중간 5자리 마스킹)
      }
      try{
        const response = await apiList.putAutoReload({...params},{prepaidCardNo: this.prepaidCardNo});
        if (response.data.code === 'S00000') {
          this.openCenterPopup('수정 되었습니다.')
        }
      } catch (error) {
        this.showBtmPopup = true
        this.btmMsg = `수정 실패했습니다.`
        console.error(error);
      }
    },
    openCenterPopup (msg) {
      this.centerPopupMsg = msg
      this.showCenterPopup = true
    },
    closeCenterPopup () {
      this.showCenterPopup = false
      //퀵계좌이체 실패 알림 팝업 닫기하면 현재 페이지 그대로 있고 메시지만 초기화
      if(this.$route.query.message) {
        this.$route.query.message = null;
      } else {
        // this.$router.replace({name: 'charging', params: {cardInfo: this.cardInfo}});
        // 2026.03.04 퀵계좌이체 추가하면서 뒤로가기시 경로를 찾지 못하는 이슈로 /home으로 가도록 히스토리 조작
        window.history.pushState(null, null, window.location.origin + '/home');
        this.$router.push({name: 'charging', params: {cardInfo: this.cardInfo}});
      }

    },
    /**
     * 한도금액설정 유의사항 문구 노출
     */
    setPrecautionsEnable() {
      const today = new Date()
      const beginDate = new Date('2026-01-26T00:00:00');

      if(today > beginDate) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 결제 방법 선택에 따른 결제수단 초기화
     * @param payToolCode
     */
    clickPayToolCode(payToolCode) {
      this.autoReloadData.autoReloadPayToolCode = payToolCode;
      // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리
      this.methodKey = payToolCode === 'ACCOUNT_TRANSFER'? this.autoReloadData.quickAccountTransferBillkey : null;
      // 퀵계좌이체 빌키가 있는 경우 빌링동의로 간주, 카드 빌링동의 여부는 this.putPaymentMerhods() 재확인
      this.billing =
          payToolCode === 'ACCOUNT_TRANSFER' && this.autoReloadData.quickAccountTransferBillkey ? true : false;
      if(payToolCode === 'CARD') { // 결제 방법 카드로 변경 시 카드 재호출
        this.putPaymentMerhods();
      }
    },
    /**
     * 퀵계좌이체 계좌 추가 후 빌링키 발급
     */
    async postAccountTransferBillingKey(customerKey, authKey) {

      //뒤로가기 시 정상동작을 위한 초기화
      this.$route.query.customerKey = null;
      this.$route.query.authKey = null;

      let params = {
        ctmmnyNo : this.$store.state.mberInfo.ctmmnyNo,
        customerKey : customerKey,
        authKey : authKey
      }
      try{
        const response = await apiList.postQuickAccountTransfer(params); //퀵계좌이체 빌링키 발급
        if (response.data.code === 'S00000') {
          let accountInfo = response.data.data;
          this.autoReloadData.autoReloadPayToolCode = 'ACCOUNT_TRANSFER';
          this.autoReloadData.quickAccountTransferBillkey = accountInfo.billingKey; // 퀵계좌이체 데이터 초기화 방지를 위해 별도로 빌키 관리
          this.methodKey = accountInfo.billingKey; // 퀵계좌이체 탭으로 methodKey 빌링키 추가
          this.autoReloadData.bankName = accountInfo.transfers[0].bankName; // 퀵계좌이체 1건만 등록 가능
          this.autoReloadData.bankAccountNumber = accountInfo.transfers[0].bankAccountNumber; // 퀵계좌이체 1건만 등록 가능
          this.billingAgreementDateTime = dayjs(accountInfo.authenticatedAt).format('YYYY-MM-DD HH:mm:ss'); // 현재날짜 + 시각
          this.billing = true;
          this.setAutoReloadAmount(); //설정한 충전 금액 세팅
        }
      } catch (error) {
        // this.showBtmPopup = true
        // this.btmMsg = `수정 실패했습니다.`
        console.error(error);
      }
    },
    /**
     * 설정한 충전 금액 세팅
     */
    setAutoReloadAmount() {
      const amountBtn = document.querySelector('#AMOUNT_' + this.autoReloadData.autoReloadAmountType);
      amountBtn.classList.add('active');
      if (this.autoReloadData.autoReloadAmountType === "WETC") {
        this.otherReloadAmount = this.autoReloadData.autoReloadAmount.toLocaleString(); // 천 단위 콤마
        this.isOtherAmount = true; // 자동 충전 금액 직접입력 input 보이도록.
      }

      if(this.autoReloadData.autoReloadType === "AMOUNT") {
        if(this.autoReloadData.autoReloadBasedAmountType !== "NONE") {
          const basedAmountBtn = document.querySelector('#BASED_AMOUNT_' + this.autoReloadData.autoReloadBasedAmountType);
          basedAmountBtn.classList.add('active');
        }
      }
      else if(this.autoReloadData.autoReloadType === "DATE") {
        for(var i = 0; i < this.autoReloadData.autoReloadDay.length; i++) {
          const dateBtn = document.querySelector('#DATE_' + this.autoReloadData.autoReloadDay[i]);
          dateBtn.classList.add('active');
        }
      }
    },
    /**
     * 결제 수단에 따른 혜택
     */
    paymentMethodBenefits(benefits) {
      // 카드 혜택(자동충전)
      this.cardBenefit = benefits.filter(el => el.payToolCode === 'CARD')[0];
      // 계좌이체 혜택(자동충전)
      this.accountTransferBenefit = benefits.filter(el => el.payToolCode === 'ACCOUNT_TRANSFER')[0];
    },
    /**
     * 결제 수단에 따른 혜택 안내
     * @param benefit
     * @returns {string}
     */
    getBenefitGuide(benefit) {

      // 혜택 안내
      let benefitGuide = '';

      if (benefit) {
        // 혜택 구분
        switch(benefit.conditionKey) {
          case 'FIXED_RATE_EXTRA_CHARGE': // %
            benefitGuide = benefit.conditionValue + '% 추가';
            break;
          case 'FLAT_EXTRA_CHARGE': // 원
            benefitGuide = benefit.conditionValue + '원 추가';
            break;
          case 'FIXED_RATE_DISCOUNT': // %
            benefitGuide = benefit.conditionValue + '% 할인';
            break;
          case 'FLAT_DISCOUNT':
            benefitGuide = benefit.conditionValue + '원 할인';
            break;
        }
      }

      return benefitGuide;
    },
    /**
     * 혜택 최소 금액 계산
     * @param value
     * @returns {string}
     */
    formattedPrice(value) {
      // 혜택 최소 금액
      if (!value) return '0원';

      const man = Math.floor(value / 10000);
      const chun = Math.floor((value % 10000) / 1000);

      let result = '';
      if (man > 0) result += `${man}만`;
      if (chun > 0) result += `${chun}천`;

      return result ? `${result}원 이상 ` : `${value}원 이상 `;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common/paymentCard.scss';
@import '@/assets/styles/pages/cards/autoCharging.scss';
@import '@/assets/styles/common/selectBoard.scss';
@import '@/assets/styles/common/selectPayment.scss';

.bottom-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}

.cash-button {
  width: rem(102) !important;
  height: rem(42) !important;
  border: 1px solid $color-gray-300;
  border-radius: rem(6);
  background-color: $color-white;
  @include font-size(rem(14), 0, 700);
  line-height: rem(42);
  color: $color-primary-gray;
  text-align: center;
}

.amountAlertMessageBox{
  font-size:14px;
  color: #C93E5F;
}

.termsAlertMessageBox{
  font-size:14px;
  color: #C93E5F;
}

.select-board.select-button-box {
  gap: rem(14) rem(7);
}
</style>